//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/NXObject.js";
import "../no/NXObject.js";
import "../no/Validation.js";
let d=[[[0,"CategoryName",0,0],[0,"ClassName",0,0],[0,"Disabled",0,0],[0,"Object",0,"NXObject",0],[0,"OutOfDate",0,0],[0,"Override",0,"Validate.Override",0],[0,"Status",1,0],[0,"TotalObjectsCount",0,0],[0,"Type",1,0]],[[["override_request"],"CreateOverrideBuilder",{R_:{builder:"Validate.OverrideBuilder"}},1,0],[[],"DeleteOverride",{},0,0],[["name"],"AskAttribute",{R_:{value:''}},1,0],[["name","numberOfAttributes","attributes"],"AskAttributes",{},1,0]],[]];
SPLM.Validate.ResultObject = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.ResultObject";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.ResultObject.ResultTypes = Object.freeze({
    "Part" : "Part", "Profile" : "Profile", "Test" : "Test", "Object" : "Object", "ObjectSet" : "ObjectSet"});

export default SPLM;